import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <svg width="18" height="18" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 3.50855L17.8612 7.36979L14 11.231L10.1387 7.36979L14 3.50855ZM13.175 2.68359C13.6306 2.22798 14.3693 2.22798 14.8249 2.68359L18.6862 6.54483C19.1125 6.97117 19.1399 7.64539 18.7684 8.10358H23.5596C23.8817 8.10358 24.1429 8.36475 24.1429 8.68691V17.5637V25.0748C24.1429 25.397 23.8817 25.6581 23.5596 25.6581H4.44036C4.11819 25.6581 3.85703 25.397 3.85703 25.0748V17.5637V8.68691C3.85703 8.36475 4.11819 8.10358 4.44036 8.10358H9.23162C8.86006 7.64539 8.88745 6.97117 9.31379 6.54483L13.175 2.68359ZM10.3893 9.27025H5.02369V16.9804H22.9762V9.27025H17.6107L14.8249 12.056C14.7702 12.1108 14.7113 12.159 14.6493 12.2006H20.373C20.6952 12.2006 20.9564 12.4617 20.9564 12.7839C20.9564 13.1061 20.6952 13.3672 20.373 13.3672H7.62689C7.30473 13.3672 7.04356 13.1061 7.04356 12.7839C7.04356 12.4617 7.30473 12.2006 7.62689 12.2006H13.3506C13.2887 12.159 13.2298 12.1108 13.175 12.056L10.3893 9.27025ZM5.02369 18.147H22.9762V24.4915H5.02369V18.147Z"
      fill="white"
    />
  </svg>,
  'Slido',
);
